import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Card, Empty, message } from 'antd'
import { Button, Form, InputGroup, Spinner } from 'react-bootstrap'

import { getSettings, updateSetting } from '../services'
import { handleError } from '../../../helpers'

export default function PointsFactorTab() {
	const { handleSubmit, register, formState: { errors } } = useForm()
	const [currentSettings, setCurrentSettings] = useState(null)

	useEffect(() => {
		!currentSettings && getSettings({
			'filter[key]': 'points_factor'
		})
			.then(res => setCurrentSettings(res.data.data))
			.catch(handleError)
	}, [ currentSettings ])

	const onSubmit = values => {
		updateSetting(currentSettings[0].id, { value: parseInt(values.value) })
			.then(res => {
				message.success(res.data.message)
				setCurrentSettings(null)
			})
			.catch(handleError)
	}

	return (
		<Card>
			{ currentSettings ? (
				<React.Fragment>
					{ currentSettings.length > 0 ? (
						<Form onSubmit={handleSubmit(onSubmit)}>
							<Form.Group>
								<Form.Label>Un punto por cada $<span className='text-danger'>*</span></Form.Label>
								<InputGroup style={{ maxWidth: '350px' }}>
									<InputGroup.Text>$</InputGroup.Text>
									<Form.Control 
										type="number"
										{...register("value", { required:true })}
										defaultValue={currentSettings[0].value}
										style={{ maxWidth: '250px' }}
									/>
									<InputGroup.Text>COP</InputGroup.Text>
								</InputGroup>
								{ errors.value && <Form.Text className='text-warning'>Este campo es requerido</Form.Text> }
							</Form.Group>
							<Button color="primary" type="submit">Actualizar Factor</Button>
						</Form>
					) : (
						<Empty description="No existe ajuste. Favor contactar a soporte@smart4.com.co" />
					)}
				</React.Fragment>
			) : <Spinner animation="border" />}
		</Card>
	)
}